module.exports = __webpack_public_path__ + "img/temperature-half.9b479962.svg";